// =============== YOUTUBE VIDEO POPUP ===============
$(document).ready(function() {
	$('#youtube-video-wrapper').magnificPopup({
    type: 'iframe'
  });
});

// =============== INDUSTRIES TAB ===============
document.addEventListener("DOMContentLoaded", function () {
  let firstindustriesTab = document.querySelector(".industries-button");
  if (firstindustriesTab) {
    firstindustriesTab.classList.add("active");
    document.getElementById("industries-" + firstindustriesTab.dataset.tab).classList.add("active");
  }
});

function switchindustriesTab(tabId) {
  let activeTabButton = document.querySelector(`.industries-button[data-tab='${tabId}']`);
  let activeTabContent = document.getElementById("industries-" + tabId);

  if (activeTabButton && activeTabContent) {
    document.querySelectorAll(".industries-button").forEach(btn => btn.classList.remove("active"));
    document.querySelectorAll(".industries-content").forEach(content => {
      content.classList.remove("active");
      content.style.opacity = 0;
    });

    activeTabButton.classList.add("active");
    activeTabContent.classList.add("active");
    setTimeout(() => {
      activeTabContent.style.opacity = 1;
    }, 100);
  }
}

// =============== INNOVATION ANIMATION ===============
document.addEventListener("DOMContentLoaded", function() {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animate');
      } else {
        entry.target.classList.remove('animate');
      }
    });
  }, { threshold: 0.5 });  // adjust sensitivity if needed

  document.querySelectorAll('.innovation-wrapper').forEach(el => {
    observer.observe(el);
  });
});



// =============== TECHNICAL-SPECIFICATIONS TAB ===============
document.addEventListener("DOMContentLoaded", function () {
    function showTabItems(tabName) {
        const front_img = document.querySelector('.technical-specifications-img.front-view');
        const back_img = document.querySelector('.technical-specifications-img.back-view');

      const all_box = document.querySelectorAll('.technical-specifications-box')

      if(all_box){
       // Hide all boxes first (optional, if only one should show at a time)
        document.querySelectorAll('.technical-specifications-box').forEach(box => {
          box.style.display = 'none';
        });
      }
      
        if(tabName.includes('Back')){
          if(front_img){
            front_img.classList.add('hidden');
          }
          if(back_img){
            back_img.classList.remove('hidden')
          }
        }else{
          if(front_img){
            front_img.classList.remove('hidden');
          }
          if(back_img){
            back_img.classList.add('hidden')
          }
        }
      
        document.querySelectorAll('.technical-specifications-item').forEach(item => {
            if (item.dataset.category === tabName) {
                item.style.display = 'block';
            } else {
                item.style.display = 'none';
                item.classList.remove('active');
                let answer = item.querySelector('.technical-specifications-answer');
                if (answer) answer.style.display = 'none';
            }
        });
    }

    function activateFirstItem(tabName) {
        let found = false;
        document.querySelectorAll(`.technical-specifications-item[data-category="${tabName}"]`).forEach((item) => {
            const answer = item.querySelector('.technical-specifications-answer');
            if (!found && answer) {
                item.classList.add('active');
                answer.style.display = 'block';
                found = true;
            } else {
                item.classList.remove('active');
                if (answer) answer.style.display = 'none';
            }
        });
    }

    // Initial setup: show only first tab's items, open only its first accordion
    const firstTab = document.querySelector('.technical-specifications-tab.active');
    if (firstTab) {
        const firstCategory = firstTab.dataset.tab;
        showTabItems(firstCategory);
        activateFirstItem(firstCategory);
    }

    // Tab switching: show only relevant items, open only the first accordion
    document.querySelectorAll('.technical-specifications-tab').forEach(tab => {
        tab.addEventListener('click', function () {
            const selectedCategory = this.dataset.tab;

            document.querySelectorAll('.technical-specifications-tab').forEach(t => t.classList.remove('active'));
            this.classList.add('active');

            showTabItems(selectedCategory);
            activateFirstItem(selectedCategory);
        });
    });

    // Accordion toggle behavior: one open at a time in visible items
    document.querySelectorAll('.technical-specifications-question').forEach(question => {
        question.addEventListener('click', function () {
            const faqItem = this.parentElement;
            const answer = faqItem.querySelector('.technical-specifications-answer');

            if (faqItem.classList.contains('active')) {
                faqItem.classList.remove('active');
                if (answer) answer.style.display = 'none';
            } else {
                document.querySelectorAll('.technical-specifications-item').forEach(item => {
                    if (item.style.display !== 'none') {
                        item.classList.remove('active');
                        let ans = item.querySelector('.technical-specifications-answer');
                        if (ans) ans.style.display = 'none';
                    }
                });
                faqItem.classList.add('active');
                if (answer) answer.style.display = 'block';
            }
        });
    });



       
    document.querySelectorAll('.point').forEach(point => {
      point.addEventListener('click', function () {
        const icon = this.querySelector('.point-icon');
        const blockId = icon?.dataset.blockId;
    
        if (!blockId) return;
    
        const matchingBox = document.querySelector(`.technical-specifications-box[data-point-id="${blockId}"]`);
        const isVisible = matchingBox && matchingBox.style.display === 'block';
    
        // Hide all boxes and remove .active from all points
        document.querySelectorAll('.technical-specifications-box').forEach(box => {
          box.style.display = 'none';
        });
        document.querySelectorAll('.point').forEach(p => {
          p.classList.remove('active');
        });
    
        if (!isVisible && matchingBox) {
          matchingBox.style.display = 'block';
          this.classList.add('active');
    
          if (window.innerWidth < 750) {
            document.body.classList.add('open_popup');
          }
        } else {
          this.classList.remove('active');
          document.body.classList.remove('open_popup');
        }
      });
    });
    
    // Close specification popup
    document.querySelectorAll('.close-icon').forEach(icon => {
      icon.addEventListener('click', function () {
        document.querySelectorAll('.technical-specifications-box').forEach(box => {
          box.style.display = 'none';
        });
        document.querySelectorAll('.point').forEach(point => {
          point.classList.remove('active');
        });
    
        if (window.innerWidth < 750) {
          document.body.classList.remove('open_popup');
        }
      });
    });


  //country selector in desktop and mobile
  document.querySelectorAll('localization-custom-form .language-selector li').forEach(item => {
    item.addEventListener('click', function () {
      const selectedLang = this.dataset.val;
      const hiddenInput = document.querySelector('#HeaderLanguageForm input[name="locale_code"]');
      const form = document.querySelector('#HeaderLanguageForm');

      if (selectedLang && hiddenInput && form) {
        hiddenInput.value = selectedLang;
        form.submit();
      }
    });
  });





});
